// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-wrapper[data-v-1ef3139e] {\n  min-height: calc(100vh - 112px - 48px);\n}", ""]);
// Exports
module.exports = exports;
